module.exports = __webpack_public_path__ + "static/media/logo-marinamunch-white.aaa3be0e.png";